import { EvidenceData } from "../../../hooks/evidences/typyng"
import { EvidencesTypeValueEnum } from "../../../utils/enums/evidences"
import { transformEvidencesNumber } from "../../../utils/methods/evidences"
import { ActivitiesListResponse, ActivityById, ConfigEvidences } from "../response"

const formatActivitiesListResponse = ({ response }: { response: ActivitiesListResponse }) => {

    const totalPages = !response.errors ? response.totalPages:1
    const row = !response.errors
      ? response?.items.map((item) => {
  
        return {
          id: item.id,
          title: item.title,
          createTime: item.createTime,
          updateTime: item.updateTime,
          deleteTime: item.deleteTime,
          activityCount: item.activityCount
        }
      })
      : []
  
    return {
      row,
      totalPages
    }
  }
  
  const formatActivityByIdResponse = ({ response }: { response: ActivityById }) => {
  
    const title = response.title ?? ''
    const idActivity = response.id
    const openField = response.openField
    const configEvidences = !response.errors
      ? response?.configEvidences?.map((item) => {
  
        return {
          id: item.id,
          evidenceTypeId: item.evidenceTypeId,
          required: item.required,
          paramsConfiguration: item.paramsConfiguration,
          description: item.description
        }
      })
      : []
  
    return {
      title, configEvidences, idActivity, openField
    }
  }
  
  
  const questiononEvidencesToEvidenceData = (evidence: ConfigEvidences[] = []): EvidenceData => {
    let newEvidences: EvidenceData = {}
    for (const item of evidence) {
        if (item?.paramsConfiguration) {
            switch (item.evidenceTypeId) {
                case EvidencesTypeValueEnum.IMAGE:
                case EvidencesTypeValueEnum.CAMERA:
                case EvidencesTypeValueEnum.DOCUMENT:
                case EvidencesTypeValueEnum.VIDEO_GALLERY:
                    newEvidences = {
                        ...newEvidences,
                        [transformEvidencesNumber[item.evidenceTypeId as EvidencesTypeValueEnum]]: {
                            "active": true,
                            "required": item.required,
                            ...!!item?.paramsConfiguration && {
                                "maxSize": {
                                    "label": `${item?.paramsConfiguration?.sizes} Mb`,
                                    "value": item?.paramsConfiguration?.sizes
                                },
                                "maxAmount": item?.paramsConfiguration?.amounts || '1',
                                "minAmount": item?.paramsConfiguration?.min || '1'
                            }
                        }
                    }
  
                    for (const itemTypes of (item?.paramsConfiguration?.types ?? [])) {
                        newEvidences[transformEvidencesNumber[item.evidenceTypeId as EvidencesTypeValueEnum]] = {
                            ...newEvidences[transformEvidencesNumber[item.evidenceTypeId as EvidencesTypeValueEnum]],
                            [itemTypes]: true
                        }
                    }
                    break;
                case EvidencesTypeValueEnum.VIDEO:
                    newEvidences = {
                        ...newEvidences,
                        [transformEvidencesNumber[item.evidenceTypeId as EvidencesTypeValueEnum]]: {
                            "active": true,
                            "required": item.required,
                            "maxSize": {
                                "label": `${item?.paramsConfiguration?.sizes} Mb`,
                                "value": item?.paramsConfiguration?.sizes
                            },
                            "maxAmount": item?.paramsConfiguration?.amounts || '1',
                            "minAmount": item?.paramsConfiguration?.min || '1'
                        }
                    }
                    break;
                case EvidencesTypeValueEnum.SIGN:
                    newEvidences = {
                        ...newEvidences,
                        [transformEvidencesNumber[item.evidenceTypeId as EvidencesTypeValueEnum]]: {
                            "active": true,
                            "required": item.required,
                            "maxAmount": item?.paramsConfiguration?.amounts || '1',
                            "minAmount": item?.paramsConfiguration?.min || '1'
                        }
                    }
                    break;
                case EvidencesTypeValueEnum.COMMENT:
                    newEvidences = {
                        ...newEvidences,
                        [transformEvidencesNumber[item.evidenceTypeId as EvidencesTypeValueEnum]]: {
                            "active": true,
                            "required": item.required,
                            "maxAmount": item?.paramsConfiguration?.amounts || '1',
                            "minAmount": item?.paramsConfiguration?.min || '1',
                            maxCharacters: item?.paramsConfiguration?.sizes
                        }
                    }
                    break;
                case EvidencesTypeValueEnum.OBSERVATION_COMMENT:
                    newEvidences = {
                        ...newEvidences,
                        [transformEvidencesNumber[item.evidenceTypeId as EvidencesTypeValueEnum]]: {
                            "active": true,
                            "required": item.required,
                            maxCharacters: item?.paramsConfiguration?.sizes
                        }
                    }
                    break;
            }
        }
    }
  
    return newEvidences
  }
  
  
  export { formatActivitiesListResponse, formatActivityByIdResponse, questiononEvidencesToEvidenceData }